import { createContext, useContext, type PropsWithChildren } from "react";
import type { AnnouncementApi } from "../data/AnnouncementApi";

const Context = createContext<AnnouncementApi | null>(null);

export function AnnouncementProvider({ api, children }: PropsWithChildren<{ api: AnnouncementApi }>) {
  return <Context.Provider value={api}>{children}</Context.Provider>;
}

export function useAnnouncementApi() {
  const value = useContext(Context);
  if (!value) throw new Error("useAnnouncementApi must be used within AnnouncementProvider");
  return value;
}

export function useOptionalAnnouncementApi() {
  return useContext(Context);
}
